import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-video-stats',
  templateUrl: './video-stats.page.html',
  styleUrls: ['./video-stats.page.scss'],
})
export class VideoStatsPage implements OnInit {
  myVideos: any = [];
  s3_url: string = environment.s3_bucket_url;
  profilePlaceholder: string = '../../../assets/images/profile-placeholder.png';
  constructor(
    private apiService: ApiService,
    private router: Router,
  ) { }

  ngOnInit() {
  }
  ionViewWillEnter(){
    this.apiService.get('users/video-stats').subscribe((res) => {
      this.myVideos = res['data'];
    });
  }
  goToProfile(user_id){
    console.log(user_id);
    this.router.navigate(['user/' + btoa(user_id)]);
  }
  playVideo(id){
    this.router.navigate(['/video-detail/'+btoa(id) ]);
  }

}
